import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum CommunityIconVariant {
  DEFAULT = 'default',
}

interface ICommunityIconProps extends IConDefaultType {
  variant?: CommunityIconVariant;
}

function CommunityIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = CommunityIconVariant.DEFAULT,
}: ICommunityIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === CommunityIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M7.49708 2.5C9.56795 2.50013 11.2469 4.17898 11.2471 6.25C11.2471 7.61241 10.5202 8.80512 9.43361 9.46191C10.2786 9.65563 11.0258 9.9756 11.6777 10.3906C11.3582 9.92384 11.171 9.35969 11.1709 8.75098C11.1709 7.13983 12.4775 5.83301 14.0889 5.83301C15.7 5.83327 17.0059 7.13999 17.0059 8.75098C17.0057 9.81132 16.4381 10.7365 15.5918 11.2471C16.721 11.5058 17.6285 12.0534 18.3164 12.7686C19.2755 13.7658 19.7838 15.059 19.916 16.2715C19.9932 16.9791 19.4076 17.4997 18.7793 17.5H1.47071C0.662991 17.5 -0.0902741 16.8307 0.00880051 15.9209C0.178751 14.3619 0.832402 12.6992 2.06544 11.417C2.94858 10.4987 4.11265 9.79605 5.56153 9.46289C4.47408 8.80629 3.74708 7.61303 3.74708 6.25C3.74723 4.17891 5.42611 2.5 7.49708 2.5ZM13.877 12.6406C14.5106 13.6727 14.8715 14.8223 14.9912 15.9209C14.9921 15.9287 14.9915 15.9366 14.9922 15.9443H18.2891C18.122 15.1837 17.7596 14.4334 17.1953 13.8467C16.5262 13.1511 15.5286 12.6378 14.0879 12.6377C14.0165 12.6377 13.9462 12.6381 13.877 12.6406ZM7.50001 10.916C5.56024 10.916 4.19119 11.6109 3.26661 12.5723C2.39264 13.4811 1.87914 14.6686 1.70118 15.833H13.2998C13.1219 14.6685 12.6075 13.4812 11.7334 12.5723C10.8088 11.6109 9.43984 10.916 7.50001 10.916ZM14.0889 7.38867C13.3365 7.38868 12.7266 7.99912 12.7266 8.75098C12.7268 9.50266 13.3366 10.1123 14.0889 10.1123C14.8409 10.112 15.451 9.5025 15.4512 8.75098C15.4512 7.99928 14.8411 7.38894 14.0889 7.38867ZM7.49708 4.16699C6.3467 4.16699 5.41325 5.09926 5.4131 6.25C5.4131 7.40087 6.34661 8.33398 7.49708 8.33398C8.64745 8.33386 9.58009 7.40079 9.58009 6.25C9.57994 5.09934 8.64736 4.16712 7.49708 4.16699Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}

export default CommunityIcon;
